import { storeToRefs } from 'pinia';
import { useQuasar } from 'quasar';
import { computed, markRaw, provide } from 'vue';

import { useScoutPanelStore } from '@/stores/ui/ScoutPanelStore.ts';
import { useChatStore } from '@/stores/v2/ChatStore.ts';

import { SCOUT_FOR_DIALOGS } from '@/components/dialogs/useScoutBesideDialog.ts';

import ScoutTrigger from '../components/ScoutTrigger.vue';

// Fullscreen Scout (below sm) stays under dialogs, so dialogs offer no trigger there.
export function useScoutForDialogs() {
  const $q = useQuasar();
  const { isOpen } = storeToRefs(useScoutPanelStore());
  const { scoutAvailable } = storeToRefs(useChatStore());

  provide(SCOUT_FOR_DIALOGS, {
    trigger: markRaw(ScoutTrigger),
    available: computed(() => scoutAvailable.value && !$q.screen.lt.sm),
    open: isOpen,
  });
}
